module.exports = __webpack_public_path__ + "static/media/settings.c01867d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/settings.svg
// module id = 898
// module chunks = 7